import React, { useState } from 'react';
import { MatchStatusControl } from './MatchStatusControl';

export const MatchStatusControlTest = () => {
  const [match, setMatch] = useState({
    id: 1,
    status: 'scheduled'
  });
  const [lineupStatus, setLineupStatus] = useState({
    homeTeam: { starting: 9, bench: 5 },
    awayTeam: { starting: 11, bench: 7 }
  });
  const [clockRunning, setClockRunning] = useState(false);
  const [captainsAssigned, setCaptainsAssigned] = useState(false);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-4">MatchStatusControl Test (Compact)</h1>
        
        {/* Test Controls */}
        <div className="bg-white p-4 rounded-lg shadow mb-4">
          <h2 className="font-semibold mb-2">Test Controls</h2>
          <div className="flex gap-4 flex-wrap">
            <button onClick={() => setMatch({...match, status: 'scheduled'})} className="px-3 py-1 bg-gray-600 text-white rounded">
              Scheduled
            </button>
            <button onClick={() => setMatch({...match, status: 'live'})} className="px-3 py-1 bg-green-600 text-white rounded">
              Live
            </button>
            <button onClick={() => setMatch({...match, status: 'finished'})} className="px-3 py-1 bg-blue-600 text-white rounded">
              Finished
            </button>
            <button onClick={() => setClockRunning(!clockRunning)} className={`px-3 py-1 rounded text-white ${clockRunning ? 'bg-red-600' : 'bg-green-600'}`}>
              Clock: {clockRunning ? 'Running' : 'Stopped'}
            </button>
            <button onClick={() => setCaptainsAssigned(!captainsAssigned)} className={`px-3 py-1 rounded text-white ${captainsAssigned ? 'bg-green-600' : 'bg-orange-600'}`}>
              Captains: {captainsAssigned ? 'Assigned' : 'Missing'}
            </button>
            <button onClick={() => setLineupStatus({
              homeTeam: { starting: 11, bench: 7 },
              awayTeam: { starting: 11, bench: 7 }
            })} className="px-3 py-1 bg-purple-600 text-white rounded">
              Complete Lineups
            </button>
          </div>
        </div>

        {/* Component */}
        <MatchStatusControl
          match={match}
          lineupStatus={lineupStatus}
          onStartMatch={() => console.log('Start match')}
          onEndMatch={() => console.log('End match')}
          onCancelMatch={() => console.log('Cancel match')}
          onNavigateToLineup={() => console.log('Navigate to lineup')}
          clockRunning={clockRunning}
          captainsAssigned={captainsAssigned}
        />
      </div>
    </div>
  );
};
